import React from "react"
import NavItems from "../components/navitems"

export default function Nav({ ariaLabel = "Primary" }) {
  return (
    <nav class="c-navigation c-navigation-md" aria-label={ariaLabel}>
      <ul class="c-navigation--list">
        <NavItems />
      </ul>
    </nav>
  )
}
